<template>
  <base-page-component>
    <div>
      <b-row>
        <b-col lg="12" md="12" sm="12" xs="12">
          <b-card>
            <div slot="header">
              <strong>New Note for Account: {{ACCOUNT_NUMBER}}</strong>
              <small></small>
              <b-btn @click="saveDealershipNotes" class="btn btn-default pull-right ml-2">
                <i title="Save" class="fa fa fa-sticky-note-o fa-lg text-white"></i> <strong class="text-white">
                  Save Note
                </strong>
              </b-btn>
              <b-btn @click="goBack" class="btn btn-warning pull-right ml-2">
                  Go back 
              </b-btn>
            </div>
         
            <b-row>
              <b-form-textarea id="txtNote"
                               v-model="txtNote"
                               placeholder="Enter note..."
                               rows="5"
                               max-rows="10"></b-form-textarea>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">Account Notes</div>
            <!-- User Interface controls -->
            <b-row>
              <b-col md="9" class="my-0">
                <b-form-group class="my-1">
                  <b-input-group v-on:keyup.enter="LoadData">
                    <!--v-on:keyup.esc="ClearSearch"-->
                    <span class="mr-2">Filter by: </span>
                    <b-form-input class="mr-2" v-model="Keyword" placeholder="Keyword" />
                    <b-input-group-append>
                      <b-btn class="btn btn-default text-white mr-2" @click="ClearSearch">
                        <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear all</strong>
                      </b-btn>
                      <b-btn class="btn btn-warning text-white mr-2" @click="getDealershipNotes">
                        <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col md="3" class="my-1"><div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div></b-col>
            </b-row>
            <!-- Main table element -->
            <b-table :items="Items" :fields="fields" hover striped bordered small :current-page="currentPage"
                     :sort-compare="onNewSort" :per-page="perPage" show-empty>

              <template slot="CREATED_TS" slot-scope="row">
                {{ row.item.CREATED_TS | formatDate }}
              </template>
              <template slot="PIN_BY" slot-scope="row">
                <span v-if="row.item.DEALERSHIP_NOTE_PIN_ID > 0">
                  <b-link @click="unpin(row.item.DEALERSHIP_NOTE_ID)">
                    <i class="fa fa-star text-warning ml-1" aria-hidden="true"></i>
                  </b-link>
                </span>
                <span v-if="row.item.DEALERSHIP_NOTE_PIN_ID == 0">
                  <b-link @click="pin(row.item.DEALERSHIP_NOTE_ID)">
                    <i class="fa fa-star text-info ml-1" aria-hidden="true"></i>
                  </b-link>
                </span>
              </template>
            </b-table>
            <!-- NAV -->
            <nav>
              <b-pagination :total-rows="GetRowCount(Items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </base-page-component>
</template>
<script>

import axios from 'axios'
import {basePageMixin} from '@/mixins/basePageMixin'
import moment from 'moment'

export default {
  components: {
  },
  mixins: [basePageMixin],
  data () {
    let self = this
    // console.log(JSON.stringify(self.$route.params.accountId))
    return {
      ACCOUNT_NUMBER: self.$route.params.accountId,
      Keyword: '',
      MESSAGE: undefined,
      txtNote : "",
      intervalHandle: undefined,
      gettingData: false,
      gettingDataInterval: 5000,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        { key: 'PIN_BY', label: 'Pin', sortable: true, tdClass: 'pin_by_column_css' },
        { key: 'CREATED_TS', label: 'Created', sortable: true, tdClass: 'created_ts_column_css' },       
        { key: 'CREATED_BY', label: 'Created_By', sortable: true, tdClass: 'created_by_column_css' },
        { key: 'DESCRIPTION', label: 'Note', sortable: true }
        
      ],
      currentPage: 1,
      perPage: 15,
    }
  },
  created () {
    let self = this
    self.getDealershipNotes();
    },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display;
    }
  },
  methods: {
    pin(DealershipNoteId) {
      let self = this
      let obj = {
        DealershipNoteId: DealershipNoteId
      }
      axios.post('/api/accounts/dealershipnotes_pin', obj)
        .then(response => {
          let res = response.data
          self.showNotification("Note Pinned");
          self.getDealershipNotes();
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    unpin(DealershipNoteId) {
      let self = this
      let obj = {
        DealershipNoteId: DealershipNoteId
      }
      axios.post('/api/accounts/dealershipnotes_unpin', obj)
        .then(response => {
          let res = response.data
          self.showNotification("Note Unpinned");
          self.getDealershipNotes();
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    GetRowCount () {
      let self = this
      return self.FilteredRecords.length
    },
    getDealershipNotes() {
      let self = this
      let obj = {
        AccountNumber: self.ACCOUNT_NUMBER || '',
        Keyword: self.Keyword || '',
        Limit: 0
      }
      axios.post('/api/accounts/getdealershipnotes', obj)
        .then(response => {
          let notes = response.data
          self.Items = notes;
        })
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })

    },
    goBack() {
      this.$router.go(-1);
    },
    saveDealershipNotes() {
      let self = this

      if (self.txtNote.length > 0) {
        let obj = {
          AccountNumber: self.ACCOUNT_NUMBER || '',
          Description: self.txtNote || ''
        }
        axios.post('/api/accounts/savedealershipnote', obj)
          .then(response => {
            let res = response.data
            console.log(res);
            self.showNotification("Note saved");
            self.getDealershipNotes();
            self.txtNote = "";

          })
          .catch(error => {
            self.handleError(error)
          }).then(r => {
            self.toggleloader(false)
          })
      }
      else {
        alert("The note is empty!")
      }
      
    },
    ClearSearch() {
      let self = this
      self.Keyword = "";
    }
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss')
      }
      return ''
    },
    formatDateToNow: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  computed: {
    FilteredRecords: function () {
      let self = this
      return self.Items

      // if (self.boolLoading) {
      //  return []
      // } else {
      //  // if (self.tbxFilter !== undefined && self.tbxFilter !== null && self.tbxFilter.length > 0) {
      //  //  return self.Items.filter(u => (u.account + '').toLowerCase().includes(self.tbxFilter.toLowerCase()) ||
      //  //      (u.accountName + '').toLowerCase().includes(self.tbxFilter.toLowerCase()))
      //  // } else {
      //  return self.Items
      //  // }
      // }
    }
  }
}</script>
<style>

  .hidden_header {
    display: none;
  }

  .table-features > tbody > tr > td,
  .table-features > tbody > tr > th {
    border: 0;
    background-color: white;
    padding: 1px;
  }
  .created_ts_column_css {
    width: 200px;
  }

  .dealership_id_column_css {
    width: 40px;
  }

  .created_by_column_css {
    width: 150px;
  }

  .pin_by_column_css {
    width: 30px;

  }
</style>



// WEBPACK FOOTER //
// src/views/AccountViewNotes.vue